export const DEFAULT_STUDENT_CODING_LANGUAGE = 'python';

export const STUDENT_CODING_LANGUAGES = [
  { value: 'python', label: 'Python' },
  { value: 'java', label: 'Java' },
  { value: 'javascript', label: 'JavaScript' },
  { value: 'cpp', label: 'C++' },
] as const;

const FREE_CHOICE_LANGUAGE_ALIASES = new Set(['any', 'free_choice', 'free choice']);

export const isFreeChoiceCodingLanguage = (language: unknown): boolean => {
  if (language == null) {
    return false;
  }
  return FREE_CHOICE_LANGUAGE_ALIASES.has(String(language).trim().toLowerCase());
};

export const formatCodingLanguageLabel = (language: unknown): string => {
  if (isFreeChoiceCodingLanguage(language)) {
    return 'Any (free choice)';
  }
  const match = STUDENT_CODING_LANGUAGES.find(
    (option) => option.value === String(language).trim().toLowerCase()
  );
  return match?.label ?? String(language);
};
